import { ProductType } from '~/core/enums';
import { convertProductsToProductDetailsList } from '~/core/utils';

export const convertTearOutsToProductDetails =
  convertProductsToProductDetailsList(ProductType.TEAR_OUT);
